module.exports = __webpack_public_path__ + "img/img12.6e068fb3.jpg";